import { render, staticRenderFns } from "./page-back.vue?vue&type=template&id=3391f3e0&scoped=true&"
import script from "./page-back.vue?vue&type=script&lang=js&"
export * from "./page-back.vue?vue&type=script&lang=js&"
import style0 from "./page-back.vue?vue&type=style&index=0&id=3391f3e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391f3e0",
  null
  
)

export default component.exports